<div class="parent-container">
  <div class="table-title-bar">
    {{tableTitle}}
  </div>
  <div class="flex-wrapper" *ngIf="tableJsonData">
    <!-- Keys column -->
    <div class="left-panel-container">
      <ng-container *ngFor="let item of values">
        <div class="left-panel-item" sa-ellipsis [placement]="'above'" *ngIf="item" [fullText]="item.resourceCaption"></div>
      </ng-container>
    </div>
    <!-- Values column -->
    <div class="right-panel-container">
      <ng-container *ngFor="let item of values">
        <div class="right-panel-item" sa-ellipsis [placement]="'above'" *ngIf="item" [fullText]="item.value"></div>
      </ng-container>
    </div>
  </div>
  <div class="empty-state-container" *ngIf="!tableJsonData">
    <img class="empty-state-image" src="{{ 'EmptyState.svg' | xsImage }}">
    <div class="empty-state-caption-top">{{ 'No_Data_Keyword' | saI18n }}</div>
  </div>
</div>
